import GlobalStyles from '@shared/theme/globalStyles';
import { ProgressBarStyle } from '@shared/components/LoadingScreen';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';
import { useScrollToTop } from '@shared/hooks/useScrollToTop';
import { InstructionsWidget } from '@app/globals/Instructions/ui/InstructionsWidget';
import { ChatWidget } from '@widgets/ChatWidget';

export const RootLayout: React.FC = observer(() => {
  useScrollToTop();

  return (
    <>
      <GlobalStyles />
      <ProgressBarStyle />
      <InstructionsWidget />
      <Outlet />
      <ChatWidget />
    </>
  );
});
